export function getDarkTheme(): boolean {
  const existing = localStorage.getItem('darkTheme');
  if (existing) { return JSON.parse(existing); }

  return true;
}

export function setDarkTheme(val: boolean) {
  localStorage.setItem('darkTheme', JSON.stringify(val));
}

// Notifications
export function getShowNotificationsOnStartup() {
  const val = localStorage.getItem('MPF_showNotificationsOnStartup');
  if (val === null) {
    return false;
  }

  return JSON.parse(val) as boolean;
}

export function setShowNotificationsOnStartup(val: boolean) {
  localStorage.setItem('MPF_showNotificationsOnStartup', JSON.stringify(val));
}
